export interface NavigationOptions {
  url: string;
  name: string;
}

export interface TourData {

  type: string;
  src: string;
  title: string;
  body: string;

}

export interface ProgressSteps {
  title: string;
  text: string;
}

export interface TabsNavigationItems {
  name: string;
  icon: string;
  selected: boolean;
  badge?: number;
}


export interface Students{
  firstName: string;
  lastName: string;
  id: number;
  avatar: string;
}

export class Preset {
  name: string;
  preset: any;
  type: string;
  id?: number;
  networkId? : number
}
